// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zSubscribedPower = z.object({
    id: z.number().int(),
    description: z.string(),
    forLargeConsumptionSite: z.boolean(),
    power: z.number().int(),
    refCountryId: z.number().int()
});

export const zSiteType = z.object({
    id: z.number().int(),
    description: z.string(),
    translationKey: z.string(),
    isUnknown: z.boolean(),
    accommodation: z.boolean()
});

export const zSiteTypeLayout = z.object({
    id: z.number().int(),
    description: z.string(),
    translationKey: z.string().nullable(),
    type: zSiteType,
    unknown: z.boolean()
});

export const zOperationType = z.object({
    id: z.number().int(),
    name: z.string()
});

export const zOperationMission = z.object({
    id: z.number().int(),
    note: z.string(),
    description: z.string()
});

export const zRefMission = z.object({
    id: z.number().int(),
    note: z.string(),
    description: z.string(),
    stopMission: z.number().int(),
    code: z.string()
});

export const zDeliveryPointObject = z.object({
    code: z.string(),
    status: z.enum([
        'NOT_ENEDIS',
        'NOT_VERIFIED',
        'VALID',
        'FORCED_VALID',
        'PROCESSING',
        'FORCED_INVALID',
        'INVALID'
    ])
});

export const zHeatPumpManualUrl = z.object({
    language: z.string(),
    url: z.string()
});

export const zHeatPumpBrand = z.object({
    id: z.number().int(),
    name: z.string(),
    status: z.enum(['VALIDATED', 'NOT_VALIDATED']),
    creationDatetime: z.string(),
    personId: z.number().int()
});

export const zHeatPumpModel = z.object({
    id: z.number().int(),
    model: z.string(),
    modopFilePath: z.string().nullable(),
    modopUrls: z.array(zHeatPumpManualUrl),
    brand: zHeatPumpBrand,
    status: z.enum([
        'NOT_VALIDATED',
        'VALIDATED_NOT_ELIGIBLE',
        'VALIDATED_ELIGIBLE'
    ]),
    creationDatetime: z.string(),
    personId: z.number().int()
});

export const zHeatPumpLinkValue = z.object({
    linkedAppliance: z.enum([
        'WATER_HEATER',
        'HEATER',
        'HEATING_FLOOR',
        'PAC_ECS',
        'OTHER'
    ]),
    value: z.boolean()
});

export const zHeatPumpSiteDeclaration = z.object({
    id: z.number().int(),
    siteId: z.number().int(),
    model: zHeatPumpModel,
    creationDatetime: z.string(),
    personId: z.number().int(),
    linkedAppliances: z.array(zHeatPumpLinkValue)
});

export const zSubscriberMyVoltalisReadModel = z.object({
    canBeImpersonated: z.boolean(),
    access: z.union([
        z.literal('MY_VOLTALIS_2016'),
        z.literal('MY_VOLTALIS_2022')
    ]).nullable()
});

export const zSubscriberFlagsReadModel = z.object({
    privileged: z.boolean(),
    vip: z.boolean()
});

export const zSubscriberCompanyRequest = z.object({
    name: z.string(),
    corporateName: z.string()
});

export const zUpdateSiteRequestPayload = z.object({
    layoutId: z.number().int().optional(),
    surface: z.number().int().optional(),
    eligibleApplianceNumber: z.number().int().optional(),
    heatPumpModels: z.array(z.object({
        heatpumpModelId: z.number().int()
    })).max(1).optional(),
    subscribedPowerTypeId: z.number().int().optional(),
    buildingOlderThan2Years: z.boolean().optional(),
    heatingSystemOlderThan2Years: z.boolean().optional(),
    grdId: z.number().int().optional(),
    subOwnerStatusTypeId: z.number().int().optional(),
    subscriberCompany: zSubscriberCompanyRequest.optional(),
    externalId: z.string().nullish()
});

export const zSiteId = z.number().int();

export const zReference = z.object({
    id: z.number().int(),
    description: z.string().nullable()
});

export const zCompany = z.object({
    id: z.number().int(),
    name: z.string(),
    fullName: z.string().nullable(),
    corporateName: z.string().nullable(),
    address: z.string().nullable(),
    postCode: z.string().nullable(),
    town: z.string().nullable(),
    type: zReference.nullable(),
    category: zReference.nullable(),
    authoriseMyvAccess: z.boolean().nullable(),
    codeEIC: z.string().nullable(),
    isSelectable: z.boolean().nullable(),
    parentIdList: z.string().nullable()
});

export const zSubscriberId = z.number().int();

export const zSubscriberEmailAddress = z.object({
    id: z.number().int(),
    subscriberId: z.number().int().nullable(),
    mail: z.string(),
    personCreator: z.number().int(),
    valid: z.boolean().optional(),
    default: z.boolean()
});

export const zPhoneNumber = z.string();

export const zPhoneDto = z.object({
    id: z.number().int().nullish(),
    phone: zPhoneNumber.nullish(),
    valid: z.boolean().nullish(),
    default: z.boolean().nullish()
});

export const zSubscriberReadModel = z.object({
    id: zSubscriberId,
    firstname: z.string(),
    lastname: z.string(),
    title: zReference.nullable(),
    mails: z.array(zSubscriberEmailAddress),
    phones: z.array(zPhoneDto),
    company: zCompany.nullable(),
    myVoltalis: zSubscriberMyVoltalisReadModel,
    flags: zSubscriberFlagsReadModel
});

export const zSimpleCompany = z.object({
    id: z.number().int(),
    name: z.string()
});

export const zOperation = z.object({
    id: z.number().int(),
    name: z.string(),
    comments: z.string().nullable(),
    startDate: z.string().date(),
    endDate: z.string().date().nullable(),
    targetEndDate: z.string().date(),
    creationDate: z.string(),
    partner: zSimpleCompany,
    type: zOperationType,
    mission: zOperationMission.nullable()
});

export const zSiteReadModel = z.object({
    id: zSiteId,
    surface: z.number().int().nullable(),
    subscribedPowerType: zSubscribedPower,
    subOwnerStatusType: zReference.nullable(),
    layout: zSiteTypeLayout.nullable(),
    partner: zCompany.nullable(),
    grd: zCompany.nullable(),
    subscriber: zSubscriberReadModel.nullable(),
    operation: zOperation.nullable(),
    buildingOlderThan2Years: z.boolean().nullable(),
    heatingSystemOlderThan2Years: z.boolean().nullable(),
    deliveryPoint: zDeliveryPointObject.nullable(),
    heatPumpDeclarations: z.array(zHeatPumpSiteDeclaration),
    mandatoryInstallation: z.boolean(),
    subscriberOffer: z.union([
        z.literal('PREMIUM'),
        z.literal('BASIC'),
        z.literal('PREMIUM_PENDING_SIGNATURE')
    ]).nullable(),
    countryIsoCode: z.string(),
    showPartnerBadge: z.boolean(),
    phoningMission: zRefMission.nullable(),
    externId: z.string().nullable(),
    eligibleApplianceNumber: z.number().int().lte(255).nullable(),
    deactivatedState: z.union([
        z.literal('DEACTIVATED_WITH_MYV'),
        z.literal('DEACTIVATED_WITHOUT_MYV')
    ]).nullable(),
    name: z.string().nullable()
});

export const zAddressProvider = z.enum([
    'GOOGLE',
    'GOUVFR',
    'UNKNOWN'
]);

export const zAddressComplement = z.object({
    complement: z.string().nullable(),
    digicode: z.string().max(45).nullable(),
    building: z.string().nullable(),
    level: z.number().int().nullable(),
    stairway: z.string().nullable()
});

/**
 * Create a non-geocoded (incomplete) address
 */
export const zCreateManualAddressRequest = z.object({
    type: z.enum(['MANUAL']),
    addressLine: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string()
}).and(zAddressComplement);

/**
 * Create an EXACT_MATCH address composed of a geocoded component only
 */
export const zCreateExactMatchAddressRequest = z.object({
    type: z.enum(['EXACT_MATCH']),
    addressProvider: zAddressProvider,
    geocodedAddress: z.record(z.unknown())
}).and(zAddressComplement);

/**
 * Create a NEARBY address composed of a geocoded component and manual input
 */
export const zCreateNearbyAddressRequest = z.object({
    type: z.enum(['NEARBY']),
    addressProvider: zAddressProvider,
    geocodedAddress: z.record(z.unknown()),
    addressLine: z.string(),
    zipCode: z.string(),
    city: z.string()
}).and(zAddressComplement);

export const zCreateSiteRequestPayload = z.object({
    countryIsoCode: z.string(),
    address: z.union([
        z.object({
            type: z.literal('MANUAL')
        }).and(zCreateManualAddressRequest),
        z.object({
            type: z.literal('EXACT_MATCH')
        }).and(zCreateExactMatchAddressRequest),
        z.object({
            type: z.literal('NEARBY')
        }).and(zCreateNearbyAddressRequest)
    ]),
    layoutId: z.number().int(),
    surface: z.number().int(),
    eligibleApplianceNumber: z.number().int(),
    heatPumpModels: z.array(z.object({
        heatpumpModelId: z.number().int()
    })).max(1),
    subscribedPowerTypeId: z.number().int().nullable(),
    buildingOlderThan2Years: z.boolean(),
    heatingSystemOlderThan2Years: z.boolean(),
    grdId: z.number().int().nullable(),
    operationId: z.number().int(),
    missionId: z.number().int(),
    subOwnerStatusTypeId: z.number().int(),
    subscriberId: z.number().int(),
    subscriberCompany: zSubscriberCompanyRequest.nullable(),
    externalId: z.string().nullable()
});

/**
 * Update the address complement of an EXACT_MATCH address
 */
export const zUpdateExactMatchAddressRequest = zAddressComplement.and(z.object({
    type: z.enum(['EXACT_MATCH'])
}));

/**
 * Update the postal component of a NEARBY address
 */
export const zUpdateNearbyAddressRequest = zAddressComplement.and(z.object({
    type: z.enum(['NEARBY']),
    addressLine: z.string(),
    city: z.string(),
    zipCode: z.string()
}));

export const zExactMatchAddress = z.object({
    geocodingStatus: z.enum(['GEOCODED']),
    street: z.string(),
    streetNumber: z.string().nullable(),
    addressLine1: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    geocodedFields: z.object({
        externalId: z.string().nullable(),
        score: z.number().nullable(),
        administrativeDivisions: z.array(z.string()),
        cityCode: z.string().nullable(),
        latitude: z.number(),
        longitude: z.number(),
        provider: zAddressProvider
    })
}).and(zAddressComplement);

export const zNearbyAddress = z.object({
    geocodingStatus: z.enum(['NEARBY']),
    addressLine1: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    nearbyFields: z.object({
        externalId: z.string().nullable(),
        streetNumber: z.string().nullable(),
        street: z.string().nullable(),
        zipCode: z.string(),
        city: z.string(),
        score: z.number().nullable(),
        latitude: z.number(),
        longitude: z.number(),
        cityCode: z.string().nullable(),
        administrativeDivisions: z.array(z.string()),
        provider: zAddressProvider
    })
}).and(zAddressComplement);

/**
 * A geocoded address (exact or nearby); considered as fully exploitable
 */
export const zSiteAddress = z.union([
    z.object({
        geocodingStatus: z.literal('GEOCODED')
    }).and(zExactMatchAddress),
    z.object({
        geocodingStatus: z.literal('NEARBY')
    }).and(zNearbyAddress)
]);

/**
 * An incomplete address; either non-geocoded or broken (data inconsistency)
 */
export const zPartialAddress = z.object({
    geocodingStatus: z.enum(['NON_GEOCODED']),
    addressLine1: z.string().nullable(),
    zipCode: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string()
}).and(zAddressComplement);

/**
 * A site with a geocoded (exact or nearby) address
 */
export const zSiteWithAddress = zSiteReadModel.and(z.object({
    address: zSiteAddress,
    partialAddress: zPartialAddress.nullable()
}));

/**
 * A site with a partial (or broken) address
 */
export const zSiteWithPartialAddress = zSiteReadModel.and(z.object({
    address: zSiteAddress.nullable(),
    partialAddress: zPartialAddress
}));

/**
 * A site with either an address or an incomplete address
 */
export const zSiteResponse = z.union([
    zSiteWithAddress,
    zSiteWithPartialAddress
]);

export const zApiError = z.object({
    code: z.string(),
    message: z.string().optional(),
    messageCode: z.string(),
    timestamp: z.string().datetime().optional(),
    path: z.string().optional(),
    data: z.record(z.unknown()).optional(),
    error: z.string().optional(),
    fieldErrors: z.record(z.unknown()).optional(),
    params: z.array(z.record(z.unknown())).optional()
});

export const zPublicPhotoId = z.string();

export const zPhotoFormat = z.enum(['HD', 'THUMBNAIL']);

export const zApplianceTypeAndLocalisation = z.object({
    type: z.string(),
    localisation: z.string().nullable()
});

export const zGeoLocation = z.object({
    latitude: z.number(),
    longitude: z.number(),
    simulated: z.boolean()
});

export const zHwModulatorId = z.number().int();

export const zCsModulatorId = z.number().int();

export const zHwMomboxId = z.number().int();

export const zDeviceSerial = z.string();

export const zPhotoSource = z.enum([
    'UNKNOWN',
    'VOLTINSTALL_CAMERA',
    'VOLTINSTALL_GALLERY'
]);

export const zPhotoDto = z.object({
    id: z.string(),
    siteId: zSiteId,
    number: z.number().int(),
    photoTypeRefId: z.number().int(),
    fileName: z.string(),
    personId: z.number().int(),
    personFirstName: z.string(),
    personLastName: z.string(),
    creationDateTime: z.string(),
    uploadDateTime: z.string(),
    hash: z.string(),
    hwModulatorId: zHwModulatorId.nullable(),
    csModulatorId: zCsModulatorId.nullable(),
    hwMomboxId: zHwMomboxId.nullable(),
    deviceSerial: zDeviceSerial.nullish(),
    url: z.string(),
    applianceTypeAndLocalisation: zApplianceTypeAndLocalisation.nullable(),
    source: zPhotoSource.nullable(),
    geolocation: zGeoLocation.nullable()
});

export const zPatchApplianceRequest = z.object({
    applianceTypeId: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }),
    localisation: z.string().max(255)
});

export const zApplianceTypeId = z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' });

export const zApplianceType = z.object({
    id: zApplianceTypeId,
    description: z.string()
});

export const zApplianceTypes = z.object({
    types: z.array(zApplianceType).optional()
});

/**
 * Site ID
 */
export const zSiteIdPathParam = zSiteId;

export const zServiceIdHeader = z.number().int();

export const zPathPublicPhotoId = zPublicPhotoId;

/**
 * Desired language for translatable response content.
 */
export const zAcceptLanguageHeader = z.string();

/**
 * OK
 */
export const zGetSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zUpdateSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zCreateSiteV2Response = zSiteResponse;

/**
 * OK
 */
export const zUpdateSiteAddressV2Response = zSiteAddress;

/**
 * OK
 */
export const zReplaceSiteAddressV2Response = z.union([
    zSiteAddress,
    zPartialAddress
]);

/**
 * OK
 */
export const zGetPhotosListResponse = z.array(zPhotoDto);

/**
 * OK
 */
export const zDownloadPhotoResponse = z.string();

/**
 * OK
 */
export const zGetApiApplianceTypeResponse = zApplianceTypes;
